import { configureStore } from '@reduxjs/toolkit';

import loadingReducer from './loading.slice'

export const store = configureStore({
    reducer: {
        loading:loadingReducer
    },
});